import type { Listing } from '@thevillages/schemas';

import type { ListingsService } from '../listings';

export function Ids(this: ListingsService): Listing[] {
  const _output: Listing[] = [];

  for (const _id of this.filteringService.ids()) {
    const _listing = this.allListings().find((l) => l.id === _id);

    if (_listing) {
      _output.push(_listing);
    }
  }

  return _output;
}
